import { React } from "react";
import { useTranslation } from "react-i18next";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import Institution from "../components/Institution";
import Courses from "../components/Courses";
import CourseByDate from "../components/CourseByDate";
import FinalClassification from "../components/FinalClassification";
import Notes from "../components/EducationNotes";
import CourseOnGoing from "../components/CourseOnGoing";
import { ValidateFields } from "../ValidateFields";
import { Row } from "react-bootstrap";

export function Education({ changeCardStatus, cardStatus }) {
  const { t } = useTranslation();
  const { searchObject, setSearchObject, onChange } = useAdvanceSearchContext();

  function clearEducation() {
    searchObject.InstitutionId = undefined;
    searchObject.courseId = undefined;
    searchObject.courseStartDate = undefined;
    searchObject.courseEndDate = undefined;
    searchObject.finalClassification = undefined;
    searchObject.notes = undefined;
    searchObject.onGoing = undefined;

    setSearchObject({
      ...searchObject
    });
  }

  return (
    <>
      <div className="accordion-item border-accordion">
        <h2
          className="accordion-header margin-accordion"
          id="headingCompetence"
        >
          <button
            className={`accordion-button border-accordion-button ${
              cardStatus ? "" : "collapsed heding-bold"
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={changeCardStatus}
            id="accordionEducation"
          >
            {`${t("Education")} ${ValidateFields.education(searchObject)}`}
          </button>
        </h2>
        <div
          id="accordionInputs"
          className={`accordion-collapse ${cardStatus ? "" : "collapse"}`}
          aria-labelledby="headingCompetence"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div className="accordion-body table-wrap ">
            <Row>
              <div className="col-md-4">
                <Institution
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <Courses
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <FinalClassification
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <CourseByDate
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-8">
                <Notes searchObject={searchObject} onChange={onChange} t={t} />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <CourseOnGoing
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
          </div>
          <div className="text-end button-clear-position">
            <button
              className="app-button btn-second btn-md"
              onClick={clearEducation}
            >
              {t("Clear Education")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
